import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { I18nextProvider, initReactI18next } from "react-i18next";
import i18next from "i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FlagsProvider } from "flagged";
import featureMap from "./config/features/features.json";

import { Icon } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import "@styles/overrule.scss";
import { Div } from "@components/Generics.react";
import Logout from "./pages/authentication/Logout";

// Lazy load components
const SuperAdmin = lazy(() => import("./pages/admin/SuperAdmin.react"));
const Login = lazy(() => import("./pages/admin/panels/Login.react")); // Lazy load the Login page

function App() {
    const isPortrait = window.innerHeight > window.innerWidth;

    i18next.use(initReactI18next).init({
        interpolation: { escapeValue: false },
    });

    const accessToken = localStorage.getItem("accessToken");
    const isAuthenticated = !!accessToken;

    return (
        <FlagsProvider features={{ ...featureMap, darkMode: window.localStorage.getItem("darkMode") === "true" }}>
            <I18nextProvider i18n={i18next}>
                <Suspense
                    fallback={
                        <Div pageht fluid flex>
                            <Div center-aligned>
                                <Icon size="big" loading name="spinner" />
                                <br />
                                <br />
                                Loading...
                            </Div>
                        </Div>
                    }
                >
                    <Router>
                        <Routes>
                            {/* If the user is not authenticated, redirect to login */}
                            <Route path="/login" element={<Login />} />
                            <Route
                                path="/adminPanel"
                                element={isAuthenticated ? <SuperAdmin /> : <Navigate to="/login" />}
                            />
                            {/* Redirect to adminPanel if authenticated, else login */}
                            <Route
                                path="/"
                                element={isAuthenticated ? <Navigate to="/adminPanel" /> : <Navigate to="/login" />}
                            />
                            <Route path="*" element={<Navigate to={isAuthenticated ? "/adminPanel" : "/login"} />} />
                            <Route path="/logout" element={<Logout/>} />
                        </Routes>
                    </Router>

                    <ToastContainer position={isPortrait ? "top-center" : "bottom-left"} autoClose={5000} closeOnClick />
                </Suspense>
            </I18nextProvider>
        </FlagsProvider>
    );
}

export default App;
